/* HTTP AI planner — proxies the real backend (API_CONTRACT.md). */
import { apiGet, apiSend } from './httpClient'
import type { AIRecommendation, TripPoint } from './types'

export interface AiPlanPreview { expected_updated_at: string; points: { title: string; type: string; day_index: number; address: string; reason?: string }[] }

/** Suggestions stay read-only until the user applies them. */
export function planTrip(tripId: string, prompt: string): Promise<AiPlanPreview> {
  return apiSend<AiPlanPreview>('POST', `/trips/${tripId}/ai/plan`, { prompt })
}

export function applyPlan(tripId: string, preview: AiPlanPreview): Promise<TripPoint[]> {
  return apiSend<TripPoint[]>('POST', `/trips/${tripId}/ai/plan/apply`, preview)
}

export function listRecommendations(tripId: string): Promise<AIRecommendation[]> {
  return apiGet<AIRecommendation[]>(`/trips/${tripId}/recommendations`)
}
